import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  mapaContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    overflowX: 'auto', // Garante rolagem no mobile se necessário
    paddingBottom: theme.spacing(1),
  },
  toothRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '6px',
    alignItems: 'center',
    margin: '0 auto 16px auto',
    minWidth: '600px', // Evita quebra de dentes em telas menores
  },
  toothRowBottom: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '6px',
    alignItems: 'center',
    margin: '0 auto',
    minWidth: '600px',
  },
  formDentes: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2.5),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(3),
  },
}))
